var map = {
	"./Calendar-Delete.png": 489,
	"./ada.png": 92071,
	"./alert_close_icon.png": 64014,
	"./api_logo_01.png": 51407,
	"./api_logo_02.png": 29940,
	"./api_logo_03.png": 51069,
	"./api_logo_04.png": 89346,
	"./ban_icon.png": 36870,
	"./batch_setting_icon_01.png": 65616,
	"./batch_setting_icon_02.png": 95787,
	"./batch_setting_icon_03.png": 5282,
	"./batch_setting_icon_04.png": 67005,
	"./batch_setting_icon_05.png": 29524,
	"./batch_setting_icon_06.png": 50991,
	"./batch_setting_icon_07.png": 69446,
	"./batch_setting_icon_08.png": 97313,
	"./bianaceLogo.png": 30749,
	"./binance.png": 34709,
	"./bitmart.png": 92350,
	"./bitmartLogo.png": 74475,
	"./btc.png": 3982,
	"./bybit.png": 24659,
	"./checked.png": 75088,
	"./close.png": 86415,
	"./close_icon.png": 91143,
	"./coinbase.png": 19139,
	"./copy-icon.png": 73456,
	"./copy_icon_white.png": 5696,
	"./cryptoicons/1inch.png": 70412,
	"./cryptoicons/ada.png": 7201,
	"./cryptoicons/akro.png": 33388,
	"./cryptoicons/ant.png": 11038,
	"./cryptoicons/atom.png": 98138,
	"./cryptoicons/bat.png": 76856,
	"./cryptoicons/bch.png": 622,
	"./cryptoicons/bnb.png": 54639,
	"./cryptoicons/btc.png": 48528,
	"./cryptoicons/btcst.png": 82057,
	"./cryptoicons/comp.png": 28436,
	"./cryptoicons/cos.png": 56712,
	"./cryptoicons/crv.png": 16170,
	"./cryptoicons/dash.png": 76161,
	"./cryptoicons/doge.png": 77290,
	"./cryptoicons/dot.png": 16764,
	"./cryptoicons/eos.png": 97986,
	"./cryptoicons/etc.png": 6999,
	"./cryptoicons/eth.png": 54548,
	"./cryptoicons/fil.png": 25420,
	"./cryptoicons/ftt.png": 94315,
	"./cryptoicons/grt.png": 13084,
	"./cryptoicons/iost.png": 64576,
	"./cryptoicons/jst.png": 56090,
	"./cryptoicons/kava.png": 50470,
	"./cryptoicons/link.png": 15625,
	"./cryptoicons/lit.png": 97682,
	"./cryptoicons/ltc.png": 93462,
	"./cryptoicons/mana.png": 86832,
	"./cryptoicons/mdx.png": 70044,
	"./cryptoicons/miota.png": 19761,
	"./cryptoicons/neo.png": 91371,
	"./cryptoicons/omg.png": 94934,
	"./cryptoicons/ont.png": 89472,
	"./cryptoicons/pancake.png": 87072,
	"./cryptoicons/reef.png": 98335,
	"./cryptoicons/rsr.png": 32420,
	"./cryptoicons/sun.png": 19307,
	"./cryptoicons/sushi.png": 7823,
	"./cryptoicons/sxp.png": 65998,
	"./cryptoicons/theta.png": 54873,
	"./cryptoicons/trx.png": 45039,
	"./cryptoicons/uni.png": 60031,
	"./cryptoicons/usdt.png": 32641,
	"./cryptoicons/xem.png": 30859,
	"./cryptoicons/xmr.png": 59972,
	"./cryptoicons/xrp.png": 93539,
	"./cryptoicons/xtz.png": 32195,
	"./cryptoicons/yfi.png": 88091,
	"./cryptoicons/yfii.png": 37746,
	"./cryptoicons/zec.png": 22707,
	"./cryptoicons/zen.png": 36710,
	"./cycle_icon.png": 95549,
	"./dash.png": 91791,
	"./down_arw.png": 74266,
	"./dropdown_icon_01.png": 67926,
	"./dropdown_icon_02.png": 49549,
	"./dropdown_icon_03.png": 93252,
	"./dropdown_icon_04.png": 74907,
	"./dropdown_icon_05.png": 77042,
	"./dropdown_icon_06.png": 67753,
	"./dropdown_icon_07.png": 12928,
	"./dropdown_icon_08.png": 57159,
	"./dropdown_icon_09.png": 38846,
	"./dropdown_icon_10.png": 49236,
	"./dropdown_icon_11.png": 86717,
	"./dropdown_icon_12.png": 45478,
	"./dropdown_icon_13.png": 84495,
	"./dropdown_icon_14.png": 41648,
	"./eth.png": 73586,
	"./eye_icon.png": 60354,
	"./fb_icon.png": 1611,
	"./gainbot_icon.png": 67211,
	"./gb_icon.png": 26114,
	"./genie.png": 23079,
	"./icon_01.png": 13076,
	"./icon_02.png": 48335,
	"./icon_03.png": 9318,
	"./icon_04.png": 2393,
	"./icon_04_old.png": 36311,
	"./icon_05.png": 5488,
	"./icon_06.png": 75339,
	"./icon_07.png": 37858,
	"./icon_08.png": 84805,
	"./icon_09.png": 55388,
	"./icon_10.png": 17394,
	"./icon_genie.png": 39709,
	"./icon_smart.png": 94230,
	"./icon_start.png": 30637,
	"./icon_zap.png": 89208,
	"./idcard_bg.png": 40786,
	"./info_icon.png": 80167,
	"./kucoin.png": 33384,
	"./kucoinLogo.png": 29401,
	"./kyc_verified_icon.png": 91705,
	"./lock.png": 63558,
	"./logo.png": 82806,
	"./logo_icon.png": 36160,
	"./menuIcon-1.png": 83555,
	"./menuIcon-10.png": 39339,
	"./menuIcon-11.png": 18210,
	"./menuIcon-12.png": 66393,
	"./menuIcon-13.png": 69488,
	"./menuIcon-14.png": 12335,
	"./menuIcon-15.png": 73318,
	"./menuIcon-16.png": 14557,
	"./menuIcon-2.png": 46696,
	"./menuIcon-3.png": 86641,
	"./menuIcon-4.png": 50526,
	"./menuIcon-5.png": 21863,
	"./menuIcon-6.png": 53388,
	"./menuIcon-7.png": 36277,
	"./menuIcon-8.png": 84274,
	"./menuIcon-9.png": 33275,
	"./message_icon.png": 81720,
	"./minus.png": 96243,
	"./modal_close_btn.png": 74059,
	"./nodata.png": 96310,
	"./nouser_icon.png": 64127,
	"./oneshot_icon.png": 28167,
	"./pause_icon.png": 69265,
	"./pause_panic_icon.png": 18377,
	"./people.png": 77634,
	"./plus.png": 75307,
	"./popup_logo.png": 15467,
	"./power.png": 6896,
	"./qr-code.png": 8270,
	"./qr_code.png": 97344,
	"./qr_code_large.png": 45396,
	"./qr_small.png": 94058,
	"./right_arw.png": 32020,
	"./search.png": 34319,
	"./shape_bottom.png": 30999,
	"./shape_top.png": 10664,
	"./shareIcon.png": 81773,
	"./share_modal_bg.png": 91384,
	"./smart.png": 42688,
	"./sol.png": 86293,
	"./sort_icon.png": 76463,
	"./start_panic_icon.png": 31811,
	"./telegram_icon.png": 89948,
	"./tic.png": 24847,
	"./trade-chart.png": 83054,
	"./trade_chart.png": 62036,
	"./uploadIcon.png": 43447,
	"./usdt.png": 79199,
	"./user.png": 5314,
	"./walletMenuIcon-1.png": 34900,
	"./walletMenuIcon-1x.png": 4518,
	"./walletMenuIcon-2.png": 40015,
	"./walletMenuIcon-2x.png": 87879,
	"./walletMenuIcon-3.png": 74822,
	"./walletMenuIcon-3x.png": 38620,
	"./walletMenuIcon-4.png": 77241,
	"./walletMenuIcon-4x.png": 22757,
	"./warning.png": 41823,
	"./whatsapp_icon.png": 48349,
	"./zap.png": 87614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;